import React, {useState} from 'react';

import TextField from '@material-ui/core/TextField';
import Theme from './Theme';
import clg from 'functions/log';
import validator from 'functions/validator';

const TextInput = ( props ) => {

    let _props = {...props};

    if( _props.hasOwnProperty("variant") ) delete _props.variant;
    if( _props.hasOwnProperty("show_validation_status") ) delete _props.show_validation_status;
    if( _props.hasOwnProperty("conditions") ) delete _props.conditions;

    const [validationStatus, setValidationStatus] = useState(false);
    const _required = ( props.required ? props.required : false );
    const _conditions = ( props.conditions ? props.conditions : null );

    const handleOnChange = (event) => {

        const _value = event.target.value;

        if( _required ) {
            const _validationStatus = ( _required ? validator.validate( {
                value : _value,
                conditions : {
                    ..._conditions
                }
            } ) : true )

            props.onChange({ value: _value, validation : {
                required : _required,
                conditions : _conditions,
                status : _validationStatus,
            } });

            setValidationStatus(_validationStatus);
        }

        if( !_required ) {
            return event;
        }
    }

    return (
        <Theme>
            <div className={`text-input-container mui-text-input ${(props.show_validation_status === 1 && !validationStatus ? " error" : "")}`}>
                <TextField variant="outlined" {..._props} size="small" fullWidth color="secondary" onChange={ (e) => handleOnChange(e) } />
            </div>
        </Theme>
    )
}

export default TextInput;